<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<section
    class="container tw-mx-auto tw-my-[50px] tw-mb-[50px] tw-items-center tw-justify-between tw-flex tw-flex-col lg:tw-flex-row tw-gap-[10px]"
>
    <div class="tw-flex tw-items-start tw-gap-[10px]">
        <img
            src="/assets/images/insurance/correct_badge.png"
            class="tw-h-[60px]"
            alt="success"
        />
        <div class="tw-ml-[10px] md:tw-ml-[50px] tw-max-w-[600px] tw-text-left">
            <h2 class="!tw-font-bold !tw-mb-[0px]">
                {{ selectedLanguage == "en" ? currentContent?.title : currentContent?.titleBm }}
            </h2>
            <p class="!tw-mb-[50px]">
                {{ selectedLanguage == "en" ? currentContent?.desc : currentContent?.descBm }}
            </p>

            <a
                href="/home"
                class="disabled:tw-opacity-70 tw-bg-[#FFA53C] tw-text-white tw-rounded-full tw-max-w-fit tw-px-[40px] md:tw-px-[80px] tw-py-[13px]"
            >
                {{ selectedLanguage == "en" ? currentContent?.btn : currentContent?.btnBm }}
            </a>
        </div>
    </div>
    <div class="tw-relative tw-hidden md:tw-block">
        <img
            src="/assets/images/insurance/about.png"
            class="lg:tw-max-w-[370px] xl:tw-max-w-[520px] tw-mx-auto"
            alt="about"
        />
    </div>
</section>

<app-footer [selectedLanguage]="selectedLanguage" />